export default __webpack_public_path__ + "static/media/kotlov.3a15627e.jpg";